/**
 * ackStore — Module-level mutable state that survives React component remounts.
 *
 * Extracted from index.html (previously inline ~lines 424-427).
 *
 * Three pieces of shared state:
 *   _ackStore           — { [clientId]: Ack[] }  acknowledgments per client
 *   _showCheckedFindings — boolean               toggle to show/hide checked findings
 *   _appCtx             — object                 global app context (functions, state refs)
 */

// --- ACK STORE (keyed by client ID) ---
const _ackStore = {};

/** @returns {{ [clientId: string]: Array<{id: number, rule_id: string, action: string}> }} */
export function getAckStore() {
    return _ackStore;
}

/**
 * Get acks for a specific client.
 * @param {string} clientId
 * @returns {Array<{id: number, rule_id: string, action: string}>}
 */
export function getAcks(clientId) {
    return _ackStore[clientId] || [];
}

/**
 * Set acks for a specific client (replaces entire array).
 * @param {string} clientId
 * @param {Array} acks
 */
export function setAcks(clientId, acks) {
    _ackStore[clientId] = acks;
}

/**
 * Check whether acks have been loaded for a client.
 * @param {string} clientId
 * @returns {boolean}
 */
export function hasAcks(clientId) {
    return clientId in _ackStore;
}

// --- SHOW CHECKED FINDINGS ---
let _showCheckedFindings = false;

/** @returns {boolean} */
export function getShowCheckedFindings() {
    return _showCheckedFindings;
}

/**
 * @param {boolean | ((prev: boolean) => boolean)} value
 */
export function setShowCheckedFindings(value) {
    _showCheckedFindings = typeof value === 'function' ? value(_showCheckedFindings) : value;
}

// --- APP CONTEXT (global context bag) ---
let _appCtx = {};

/** @returns {object} */
export function getAppCtx() {
    return _appCtx;
}

/**
 * Replace the entire app context object.
 * @param {object} ctx
 */
export function setAppCtx(ctx) {
    _appCtx = ctx;
}

/**
 * Merge additional properties into the existing app context.
 * @param {object} patch
 */
export function patchAppCtx(patch) {
    Object.assign(_appCtx, patch);
}
